// DRIFT WARNING: these URL-segment prefix VALUES are mirrored in sitemap-service
// (src/sources/provider-directory/url-builder.ts), guarded by its slug-contract spec.
// Changing any of these string values must be reflected there too or the sitemap's
// canonical URLs stop matching the directory links built here. (Member declaration order
// is irrelevant at runtime — the emitted segment order lives in the composition functions.)
export enum URIPrefix {
  AGE = 'age',
  CITY = 'cty',
  GENDER = 'gdr',
  INSURANCE = 'ins',
  LANGUAGE = 'lng',
  MODALITY = 'mod',
  SESSION_TYPE = 'sess',
  SPECIALTY = 'spc',
  STATE = 'sta',
  TREATMENT_PREFERENCE = 'tap'
}
